/**
 * Branch Select Component
 * Dropdown untuk memilih cabang (digunakan di form user, dll)
 */
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../../store/store';
import { fetchBranchesAsync } from './branchSlice';

interface BranchSelectProps {
  value: number | undefined;
  onChange: (branchId: number) => void;
  required?: boolean;
  disabled?: boolean;
  includeInactive?: boolean;
}

const BranchSelect: React.FC<BranchSelectProps> = ({
  value,
  onChange,
  required = false,
  disabled = false,
  includeInactive = false,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { branches, loading } = useSelector((state: RootState) => state.branch);
  const currentUser = useSelector((state: RootState) => state.auth.user);

  useEffect(() => {
    // Fetch branches jika belum ada
    if (branches.length === 0) {
      dispatch(fetchBranchesAsync({ include_inactive: includeInactive }));
    }
  }, [dispatch, branches.length, includeInactive]);

  // Filter branches based on user role
  const availableBranches = React.useMemo(() => {
    if (currentUser?.role === 'owner') {
      return branches;
    }
    // Non-owner hanya bisa lihat cabang sendiri
    return branches.filter(b => b.id === currentUser?.branch_id);
  }, [branches, currentUser]);

  return (
    <select
      value={value || ''}
      onChange={(e) => onChange(parseInt(e.target.value))}
      required={required}
      disabled={disabled || loading}
      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
    >
      <option value="">-- Pilih Cabang --</option>
      {availableBranches.map((branch) => (
        <option key={branch.id} value={branch.id}>
          {branch.code} - {branch.name}
          {!branch.is_active && ' (Nonaktif)'}
        </option>
      ))}
    </select>
  );
};

export default BranchSelect;
